import { ReportbranchrevenueService } from 'src/services/reportbranchrevenue.service';
import { showToast } from 'src/utils/common';
import {
    DEFAULT_ROW_PER_PAGE,
  } from 'src/utils/constants';

import { AppAction } from './app.action';

export const REPORTBRANCHREVENUE_UPDATE_FILTER = 'REPORTBRANCHREVENUE:REPORTBRANCHREVENUE_UPDATE_FILTER'

export const REPORTBRANCHREVENUE_NEW_CARE_SUCCESS = 'REPORTBRANCHREVENUE:NEW_CARE_SUCCESS'
export const REPORTBRANCHREVENUE_LIST_SUCCESS = 'REPORTBRANCHREVENUE:FIND_ALL_SUCCESS'
export const REPORTBRANCHREVENUE_LIST_FAILD = 'REPORTBRANCHREVENUE:FIND_ALL_FAILD'
export const REPORTBRANCHREVENUE_COUNT_ASSIGN_SUCCESS = 'REPORTBRANCHREVENUE:COUNT_ASSIGN_SUCCESS'
export const REPORTBRANCHREVENUE_COUNT_ASSIGN_FAILD = 'REPORTBRANCHREVENUE:COUNT_ASSIGN_FAILD'

export const REPORTBRANCHREVENUE_CREATE_SUCCESS = 'REPORTBRANCHREVENUE:CREATE_SUCCESS'
export const REPORTBRANCHREVENUE_CREATE_FAILD = 'REPORTBRANCHREVENUE:CREATE_FAILD'

export const REPORTBRANCHREVENUE_IMPORT_SUCCESS = 'REPORTBRANCHREVENUE:IMPORT_SUCCESS'
export const REPORTBRANCHREVENUE_SAVE_SUCCESS = 'REPORTBRANCHREVENUE:SAVE_SUCCESS'
export const REPORTBRANCHREVENUE_SAVE_FAILD = 'REPORTBRANCHREVENUE:SAVE_SUCCESS'

export const REPORTBRANCHREVENUE_DEL_SUCCESS = 'REPORTBRANCHREVENUE:DEL_SUCCESS'
export const REPORTBRANCHREVENUE_DEL_FAILD = 'REPORTBRANCHREVENUE:DEL_FAILD'


export const REPORTBRANCHREVENUE_HISTORY_LIST_SUCCESS = 'REPORTBRANCHREVENUE:HISTORY_FIND_ALL_SUCCESS'
export const REPORTBRANCHREVENUE_HISTORY_LIST_FAILD = 'REPORTBRANCHREVENUE:HISTORY_FIND_ALL_FAILD'

export const REPORTBRANCHREVENUE_LIST_EXPORT_SUCCESS = 'REPORTBRANCHREVENUE:FIND_ALL_EXPORT_SUCCESS'
export const REPORTBRANCHREVENUE_LIST_EXPORT_FAILD = 'REPORTBRANCHREVENUE:FIND_ALL_EXPORT_FAILD'

export const ReportbranchrevenueAction = {
    list,
    listExport,
    findAssign,
    create,
    updateFilter,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    updateUser,
}


function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTBRANCHREVENUE_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { reportbranchrevenue } = getState()
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...reportbranchrevenue.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTBRANCHREVENUE_LIST_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { reportbranchrevenue } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = reportbranchrevenue;
        
        ReportbranchrevenueService.findAll(filter.page, filter.limit, filter).then((rs) => {
            if (!!filter && filter.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count,
                    tongDoanhThuTamTinh: rs.data.tongDoanhThuTamTinh,
                    tongDoanhThuThucTe: rs.data.tongDoanhThuThucTe,
                    tongHoanTien: rs.data.tongHoanTien,
                    tongGoi: rs.data.tongGoi,
                }));
            } else {
                dispatch(success({
                    items: [...reportbranchrevenue.items, ...rs.data.values],
                    total: rs.data.count,
                    tongDoanhThuTamTinh: rs.data.tongDoanhThuTamTinh,
                    tongDoanhThuThucTe: rs.data.tongDoanhThuThucTe,
                    tongHoanTien: rs.data.tongHoanTien,
                    tongGoi: rs.data.tongGoi,
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTBRANCHREVENUE_LIST_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_LIST_FAILD, error } }
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { reportbranchrevenue } = getState();

            const { filter } = reportbranchrevenue;

            // Perform your asynchronous operation (e.g., API call)
            ReportbranchrevenueService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: REPORTBRANCHREVENUE_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_LIST_EXPORT_FAILD, error } }
}

function updateFilter(payload) {
    return { type: REPORTBRANCHREVENUE_UPDATE_FILTER, data: payload }
}

function importData(payload) {
    return { type: REPORTBRANCHREVENUE_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            ReportbranchrevenueService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(ReportbranchrevenueAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: REPORTBRANCHREVENUE_SAVE_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_SAVE_FAILD, error } }
}

function update(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(ReportbranchrevenueAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTBRANCHREVENUE_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_CREATE_FAILD, error } }
}

function updateUser(username, track0, track1) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.updateUser(username, track0, track1).then((rs) => {
            
        }).catch((error) => {
            
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(ReportbranchrevenueAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTBRANCHREVENUE_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(ReportbranchrevenueAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTBRANCHREVENUE_DEL_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_DEL_FAILD, error } }
}


function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(ReportbranchrevenueAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { reportbranchrevenue } = getState()
        dispatch(AppAction.appLoading(true));
        ReportbranchrevenueService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...reportbranchrevenue.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REPORTBRANCHREVENUE_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: REPORTBRANCHREVENUE_HISTORY_LIST_FAILD, error } }
}